exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.poor-layout[data-v-60e89fcc] {\n  position: absolute;\n  left: 0;\n  right: 0;\n  padding: 0 50px;\n  top: 0.3rem;\n  bottom: 0.3rem;\n  overflow: hidden;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-60e89fcc","scoped":true,"hasInlineConfig":true}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/views/poorInfo/index.vue
// module id = 721
// module chunks = 1